import _ from 'underscore';
import Backbone from 'backbone';

function parseRefillType(type) {
  switch (type) {
    case 'free':
      return '무료';
    case 'howpcbang':
      return '하우PC방';
    case 'silverclass':
      return '실버클래스';
    case 'goldclass':
      return '골드클래스';
  }
}

export var RefillModel = Backbone.Model.extend({
  url: 'refill',

  defaults: function () {
    return {
      resultCode: 0,
      resultText: '',

      refillType: 0,
      refillTypeText: '',

      remainingChances: 0,
      totalChances: 0,

      refillMoney: 0,
      refillCondition: 0,

      title: '',
      resultMessage: ''
    };
  },

  initialize: function () {
    _.bindAll(this, 'claimRefill');
  },

  parse: function (res) {
    return _.extend(res.result, {
      title:
        parseRefillType(res.result.refillTypeText) +
        (res.result.resultText === 'success' ? ' 리필 지급 완료' : ' 리필 안내'),
      resultMessage: res.result.refillTypeText + '/' + res.result.resultText
    });
  },

  claimRefill: function () {
    this.save();
  }
});
